<template>
  <entity-edit-dialog
      @submit="submit"
      @close="close"
      v-model="visible"
      ref="editDialog"
      :dialog-title="dialogTitle"
      :submitting="submitting"
      :max-width="700">
    <template v-slot:contentCard>
      <v-card-text class="pt-5">

        <entity-dialog-input-row :label="$t('siteNotification.type')" :required="true">
          <site-notification-type-select v-model="siteNotification.type"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('siteNotification.startTime')" :required="true">
          <date-picker v-model="siteNotification.startTime"
                       :rules="[buildRequiredValidator(),]"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('siteNotification.endTime')">
          <date-picker v-model="siteNotification.endTime" clearable/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('siteNotification.active')">
          <v-checkbox :label="$t('siteNotification.activeTrue')"
                      v-model="siteNotification.active"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('siteNotification.title')" :required="true">
          <v-text-field v-model="siteNotification.title"
                        outlined
                        hide-details="auto"
                        style="max-width: 20em"
                        autocomplete="false"
                        :rules="[buildMaxLengthValidator(256), buildRequiredValidator(),]"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('siteNotification.message')" :required="true">
          <v-textarea v-model="siteNotification.message"
                      rows="3"
                      outlined
                      hide-details="auto"
                      autocomplete="false"
                      :rules="[buildMaxLengthValidator(3000), buildRequiredValidator(),]"/>
        </entity-dialog-input-row>

      </v-card-text>
    </template>
  </entity-edit-dialog>
</template>

<script>
import EntityDialogInputRow from '@/components/entity-crud/EntyDialogInputRow';
import i18n from '@/i18n';
import EntityEditDialog from '@/components/entity-crud/EntityEditDialog';
import { buildMaxLengthValidator, buildRequiredValidator } from '@/utils/ValidatorBuilders';
import SiteNotificationsService from '@/services/SiteNotificationsService';
import DateUtils from '@/utils/DateUtils';
import DatePicker from '@/components/inputs/DatePicker';
import SiteNotificationTypeSelect from '@/views/sitenotification/SiteNotificationTypeSelect';

export default {
  name: 'SiteNotificationDialog',
  components: {
    SiteNotificationTypeSelect,
    DatePicker,
    EntityEditDialog,
    EntityDialogInputRow,
  },
  data: () => ({
    siteNotification: null,
    visible: false,
    submitting: false,
  }),
  props: {},
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    dialogTitle() {
      if (this.siteNotification?.id) {
        return i18n.t('siteNotification.editDialog.titleEdit');
      } else {
        return i18n.t('siteNotification.editDialog.titleAdd');
      }
    },
  },
  methods: {
    buildRequiredValidator,
    buildMaxLengthValidator,
    close() {
      this.siteNotification = null;
      this.visible = false;
      this.submitting = false;
    },

    openCreateNewSiteNotification() {
      this.siteNotification = {
        title: null,
        type: 'INFO',
        startTime: DateUtils.toLocalISOdate(new Date()),
        endTime: null,
        message: null,
        active: true,
      };
      this.visible = true;
    },

    openEditForSiteNotification(siteNotificationId) {
      SiteNotificationsService.get(siteNotificationId)
          .then(result => {
            this.siteNotification = result.data;
            this.visible = true;
          }).catch(err => {
        console.log(JSON.stringify(err));
      });
    },


    submit() {
      if (this.submitting) {
        return;
      }

      if (!this.$refs.editDialog.$refs.form.validate()) {
        this.$refs.editDialog.showFormHasValidationErrorsMessage(i18n.t('siteNotification.requiredInformationMissing'));
        return;
      }

      this.submitting = true;
      SiteNotificationsService.save(this.siteNotification).then((result) => {
        this.$emit('done', result.data);
        this.close();
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.submitting = false;
      });
    },
  },
};
</script>

<style scoped>
.repeat-weekdays > * {
  margin-right: 1em;
}
</style>
